export default "__VITE_ASSET__BkT8qHjJ__"